//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImgWrap from '@/components/business/img_wrap'
export default {
    components: {
        ImgWrap
    },
    props: {
        item: Object
    },
    methods: {
        openDetail () {
            this.$router.push({
                path:`/building?building_id=${this.item.building_id}`
            })
        }
    }
}
